import validator from 'validator'

import type { IdValidationStrategy } from 'modules/legal_entities/lib/types'

import validateDni from './dniValidator'
import { SpainIdType } from './idType'
import validateNaf from './nafValidator'
import validateNie from './nieValidator'

class SpainIdValidationStrategy implements IdValidationStrategy {
  constructor(private idType: SpainIdType, private id: string, private idLabel: string) {}
  isValid(): boolean {
    if (this.disabled()) return true

    switch (this.idType) {
      case SpainIdType.DNI:
        return validateDni(this.id)
      case SpainIdType.NIE:
        return validateNie(this.id)
      case SpainIdType.PASSPORT:
        return validator.isPassportNumber(this.id, 'ES')
      case SpainIdType.SOCIAL_SECURITY_NUMBER:
        return validateNaf(this.id)
      default:
        return false
    }
  }
  errors(): string {
    if (!this.isValid()) {
      return `Invalid ${this.idLabel} number`
    }
    return ''
  }

  disabled(): boolean {
    return SpainIdType.PASSPORT == this.idType
  }
}

export default SpainIdValidationStrategy
